import { useFormContext, useWatch } from "react-hook-form";
const useValue = (props)=>{
    const { control  } = useFormContext();
    return useWatch({
        ...props,
        control
    });
};
export default useValue;

//# sourceMappingURL=useValue.js.map